var map = {
	"./de/mechaName.png": "N+tz",
	"./en/mechaName.png": "HXL1",
	"./es/mechaName.png": "qBQg",
	"./fr/mechaName.png": "5aq1",
	"./ja/mechaName.png": "4VN9",
	"./ko/mechaName.png": "jfE0",
	"./pt/mechaName.png": "gZC3",
	"./ru/mechaName.png": "PUVr",
	"./tc/mechaName.png": "1/D7",
	"./th/mechaName.png": "F4kv"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YYiv";